"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Skeleton = require("../../../../../../shared/uikit/Skeleton");

var FileAttachmentSkeleton = function FileAttachmentSkeleton(_ref) {
  var icon = _ref.icon,
      label = _ref.label;
  return (0, _preact.h)("div", {
    className: "attachment__link file-attachment",
    style: {
      position: 'relative',
      pointerEvents: 'none',
      opacity: 0.7
    }
  }, (0, _preact.h)(_Skeleton.RectangleSkeleton, {
    width: "100%",
    height: "100%",
    borderRadius: "0",
    style: {
      position: 'absolute',
      top: 0,
      left: 0
    }
  }), (0, _preact.h)("div", null, icon, (0, _preact.h)("span", {
    className: "file-attachment--filename"
  }, label)));
};

var _default = FileAttachmentSkeleton;
exports.default = _default;